import styled from 'styled-components';

export const ModalContainer = styled.div<{ isOpen: boolean }>`
  display: ${props => (props.isOpen ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  border: 1px solid rgb(204, 204, 204);
  background: rgb(255, 255, 255);
  padding: 20px;
  border-radius: 10px;
  text-align: right;
`;
